export const BASE_URL = 'https://observatorioeconomico.ciudaddecorrientes.gov.ar';
export const API_URL = 'https://ciudaddecorrientes.gov.ar/api/v1.0';
export const STAT_ANIMATION_DURATION = 5000;
export const INSTITUCIONAL_PAGE_ID = 31062;